enum ResultStatus {
  Succeeded = 'Succeeded',
  InvalidRequest = 'InvalidRequest',
  Unauthorized = 'Unauthorized',
  Forbidden = 'Forbidden',
  MissingResource = 'MissingResource',
  Conflict = 'Conflict',
  ExpiredResource = 'ExpiredResource',
  ProcessingError = 'ProcessingError',
  DependencyFailure = 'DependencyFailure',
  ClientError = 'ClientError',
  Unspecified = 'Unspecified'
}

export default ResultStatus;
